

tippy('.popup_cancel_top_cross', {
	content: '<span class="tooltip">Close <span class="key">(esc)</span></span>',
	allowHTML: true,
	followCursor: true,
	theme: 'translucent',
});
tippy('#changeStatusSelected', {
	content: 'Select a row',
	followCursor: true,
	theme: 'translucent',
});
tippy('#deleteSelected', {
	content: 'Select a row',
	followCursor: true,
	theme: 'translucent',
});
